import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { ForgotPassService } from 'src/app/services/forgot-pass.service';
import { PermissionService } from 'src/app/services/permission.service';
import { Alert } from 'src/app/shared/models/Alert';
import { SimpleRequestString } from 'src/app/shared/models/SimpleRequestString';
import { AlertService } from 'src/app/shared/services/alert.service';

import { FormsModule } from '@angular/forms';
@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.css'],
    imports: [FormsModule, RouterModule]
})
export class ForgotPasswordComponent {
  usrEmail: string = '';
  errorMessage: string = '';
  fieldsCompleted: boolean = false;
  showPassword: boolean = false;
  hoverClassAdded: boolean = false;
  simpleRequestString: SimpleRequestString = {};
  alert: Alert = {} as Alert;

  constructor(private router: Router, private forgotPassService: ForgotPassService, private alertService: AlertService) {  }

  onSubmit(): void {
    this.simpleRequestString.value = this.usrEmail;

    this.forgotPassService.validateEmailExist(this.simpleRequestString).subscribe(
      ({ StatusCode, Message, Data }) =>
        Data !== false
          ? this.handleValidEmail(Data)
          : this.handleNotValidEmail(StatusCode),
      (error) => {
        this.alert = {
          alertMessage: 'Unexpected error. Please try again later.',
          alertType: 'alert alert-danger',
          alertCenter: false,
          alerTitle: '',
          duration: 3000
        };
        this.alertService.updateAlertState(
          this.alert
        );

        this.clearFields();
      }
    );
  }

  handleNotValidEmail(StatusCode: number) {
    this.alert = {
      alertMessage: 'The email you entered does not exist. Please check that you have typed your email correctly.',
      alertType: 'alert alert-danger',
      alertCenter: false,
      alerTitle: '',
      duration: 3000
    };
    this.alertService.updateAlertState(
      this.alert
    );
    this.clearFields();
  }

  clearFields() {
    this.usrEmail = '';
    this.fieldsCompleted = false;
  }

  handleValidEmail(response: boolean) {
    localStorage.setItem('UserEmail', this.usrEmail);
    this.router.navigate(['/verify-new-password']);
  }

  checkFields() {
    if (this.usrEmail) {
      this.fieldsCompleted = true;
    } else {
      this.fieldsCompleted = false;
    }
  }

  addHoverClass() {
    this.hoverClassAdded = true;
  }

  removeHoverClass() {
    this.hoverClassAdded = false;
  }

  returnToLogin() {
    localStorage.clear();
    this.router.navigate(['/login']);
  }
}
